/**
 * Menu "Ajuda": abre o WhatsApp do suporte direto na conversa, com a mensagem já preenchida
 * (inclui a empresa e o CNPJ ativos para o suporte saber quem está pedindo ajuda).
 */
export const WHATSAPP_SUPORTE = '551139637707'; // (11) 3963-7707

const soDigitos = (v) => String(v ?? '').replace(/\D/g, '');

/** 00.000.000/0000-00 (devolve o texto original se não tiver 14 dígitos). */
export const formataCnpj = (cnpj) => {
    const d = soDigitos(cnpj);
    return d.length === 14
        ? d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5')
        : String(cnpj ?? '');
};

export const montaLinkAjuda = ({ cnpj = '', razaoSocial = '' } = {}) => {
    const linhas = ['Olá! Preciso de ajuda com o Lance Fácil.'];
    if (razaoSocial) linhas.push(`Empresa: ${razaoSocial}`);
    if (cnpj) linhas.push(`CNPJ: ${formataCnpj(cnpj)}`);
    return `https://wa.me/${WHATSAPP_SUPORTE}?text=${encodeURIComponent(linhas.join('\n'))}`;
};
